module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_vm._v("MAKIN’S FROM CORN AND CORNMEAL")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title2"
  }, [_vm._v("THE SOUL OF APPALACHIAN COOKING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If bread lies at the heart of Appalachian culinary ways, baked goods using cornmeal can sort of be reckoned the mother church of the bread family. Corn as a crop has always been ideally suited to the region’s geography. A patch can be grown almost anywhere there is a piece of cleared ground, from steep hillsides to fertile river bottomland and all types of topography in between. Moreover, corn is a crop featuring exceptional versatility. Freshly picked corn in the form of roasting ears is a summertime dietary treat that can, with successive plantings, be enjoyed over a time span of as long as three months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The primary usage of corn, however, has always come in its fully matured, dried form. It is ideally suited for human consumption not only thanks to its taste but also because the grain stores well (corn with the shucks left intact will, if protected from moisture and pests such as rats and weevils, keep almost indefinitely). Historically, it could be ground in small quantities in simple tub mills as well as larger, more complex overshot waterwheel operations. This translated to ready production of meal in a process that was appreciably less complex than the milling of other grains such as wheat, rye or buckwheat. With corn, there was minimal waste. Leavings from poorly formed or inferior ears, sometimes called nubbins, served admirably as scratch feed for chickens or as supplemental food for hogs in the fattening-up times of autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Corn fodder fed livestock and, when stacked in shocks, provided a makeshift yet eminently practical means of food storage to protect long-keeping vegetables such as pumpkins, potatoes and cabbage from freezing during the depths of winter’s cold. Cobs from shelled corn could be fashioned into jug stoppers, carved to make pipes or soaked in kerosene to provide a dandy fire starter. Corn was, in short, an ideal crop, and that holds true even without venturing into the fabled traditions associated with the grain in its liquid form. The recipes that follow are but a slender sampling of the ways in which it can be prepared, and all these focus on its use in the making of bread. Other usages for corn as a fresh vegetable occur later in the book.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A bunch of boys, hoes in hand, ready to get busy with weed chopping in a corn patch. "), _c('i', [_vm._v("Courtesy of Hunter Library, Western Carolina University.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of the myriad methods for using corn, baking it in what was normally called pone was the most common. Yet the word "), _c('i', [_vm._v("cornbread")]), _vm._v(" embraced an array of preparations, with ingredients varying quite remarkably. An example of that consideration is provided by the methods our families have used, and our respective recipes for it provide two illustrations of how to prepare this most traditional of Appalachian foodstuffs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, cornbread merely forms a starting point for the many baked variations—fritters, hushpuppies, dodgers, corn cakes (cooked on a griddle just like pancakes), etc.—that can be made from cornmeal. Then there are so many things you can add to the batter—cracklings, jalapeños or other “hot” stuff for Mexican cornbread, corn kernels and the like. What is offered here is nothing more than a small sampling of the unending delights afforded by cornmeal.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Tipper’s Cornbread")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("Cornbread is the quintessential bread of Appalachia. Although batter recipes vary, the key to making traditional cornbread is to use a preheated cast-iron pan for baking.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("Bacon fat or lard")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 cups self-rising white cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 egg, beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("¼ cup vegetable oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1⅓ cups milk")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Grease cast-iron pan liberally with bacon fat or lard. Place in cold oven and preheat to 475 degrees. Place 2 cups cornmeal in mixing bowl. Combine egg, oil and milk and then pour into bowl with cornmeal and mix thoroughly. Carefully remove heated pan from oven and add batter. Bake for 20 minutes or until done.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" Plain cornmeal can also be used by adding 1 teaspoon of baking soda and 1 teaspoon of salt.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" Sprinkling the hot pan with cornmeal before adding your batter will make an even crisper crust.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P23-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A perfectly browned pone of cornbread hot from a cast-iron skillet. "), _c('i', [_vm._v("Tipper Pressley.")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Cornbread the Casada Way")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("“My way” simply means cornbread as it has long been made in my family, and with slight variations, I think you’ll find the recipe that follows is fairly standard among the folks of southern Appalachia. Some key points, before we even get to the recipe, are:")])]), _vm._v(" "), _c('ol', [_c('li', [_c('i', [_vm._v("Cook in a well-greased cast-iron skillet.")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Grease the skillet with a piece of streaked meat or bacon before you pour in the batter.")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Use stone-ground cornmeal. Store-bought stuff is ground at too high a rate, and heat hurts its flavor. Also, if you like a bit of crunch in your cornbread, and I do, stone-ground meal, even if sifted, has more “body” to it.")])]), _vm._v(" "), _c('li', [_c('i', [_vm._v("Use buttermilk, not sweet milk. This recipe makes just the right size pone for a standard 9-inch cast-iron skillet. A frequently uttered adage holds that “yellow corn is for critters and white corn for folks,” but my personal preference is for yellow cornmeal.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 extra-large egg")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1⅓ cups buttermilk")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("¼ cup bacon drippings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 cups stone-ground yellow cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Cracklings (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("⅓ cup frozen corn kernels (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Preheat your oven to 400 degrees. Mix all the ingredients in a large bowl and whisk until thoroughly blended. Place the pan—well seasoned by rubbing in a bit of the bacon grease or by running a piece of streaked meat across it after the pan is hot—in the oven for a few minutes. Then take out and pour the batter into the pan, return to the oven and cook until golden brown.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P24-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gritting corn from the cob. "), _c('i', [_vm._v("Jim Casada.")])])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIPS:")])]), _vm._v(" "), _c('ol', {
    staticClass: "num"
  }, [_c('li', [_vm._v("If you have access to cracklings, add a handful to the batter when you stir it up and cut back just a tad on the bacon drippings.")]), _vm._v(" "), _c('li', [_vm._v("For a bit more moisture and a nice texture surprise, add ⅓ cup of frozen corn kernels (thaw them in advance) to the batter.")]), _vm._v(" "), _c('li', [_vm._v("When you remove the cooked pone from the oven, place a couple of pats of butter atop it and, as they melt, spread them across the crust.")])]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Jim Casada")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Cornbread and Milk")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("Since cornbread is so common in the mountains of Appalachia, a need to use leftover bread often arises. One of the most popular ways to use any remaining cornbread is to mix it with milk. Fill a glass with crumbled cornbread and pour either sweet milk or buttermilk over it.")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTES:")])]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_vm._v("1. Onions, salt and pepper can be added to the glass for a richer meal.")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_vm._v("2. Honey and other sweeteners can be added to make the dish more of a sweet dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" Cornbread and milk makes a great breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A glass of cornbread and milk, often served as supper in the Appalachians. "), _c('i', [_vm._v("Tipper Pressley.")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Cornbread Salad")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("Another wonderful way to use leftover cornbread is to make a big bowl of cornbread salad. The recipe couldn’t be easier. The ingredients can be changed according to what you have on hand. The amounts can be adjusted to fit the amount of cornbread you have, as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Onion, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Tomato, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 (8-ounce) can beans (pinto and kidney work well)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 handful shredded cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Your favorite dressing (ranch works especially well)")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Crumble cornbread in a large bowl. Add onion, tomato, beans and cheese, season to taste and dress salad.")]), _vm._v(" "), _c('p', {
    staticClass: "steps2"
  }, [_vm._v("Peppers, radishes, cucumbers and other vegetables can be added.")]), _vm._v(" "), _c('p', {
    staticClass: "steps2"
  }, [_vm._v("The ingredients can be layered in a glass bowl for a pretty presentation, but I prefer to mix them all together.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" The salad is better after it marries in the fridge overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" The salad makes a perfect quick weekday supper.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Hushpuppies")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("Aunt Mag Williams, a wonderful Black cook from my youth, always had piping hot hushpuppies (and slaw) to go with fish. I have no idea how she made them, but as is true of this recipe, they did have as essential ingredients cornmeal and onion. She often, though not always, included corn kernels in her batter. This was in the summertime, when fresh corn on the cob was readily available.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("1½ cups cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup self-rising flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("½ teaspoon seasoned garlic salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("½ cup chopped onion (or scallions)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 (8-ounce) can cream-style corn")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 egg")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Cooking oil")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Combine the cornmeal, flour and garlic salt in a bowl and mix well. Beat the onion, corn, eggs and milk in a separate bowl and add them to the dry ingredients. Place the mixture in the freezer to cool while you heat cooking oil to 375 degrees in a deep fryer. Drop teaspoons of the batter, just a few hushpuppies at a time, into the hot oil. Cook until golden brown, turning to cook evenly on all sides. Makes about 30 large hushpuppies.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" Recipe can be doubled (or expanded by other multiples).")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Jim Casada")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Pap’s Gritted Bread")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("1½ cups grated corn (if using really fresh corn, allow some of the milk to drain out)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("⅔ cup all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("½ teaspoon baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 teaspoon baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 egg, beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup sweet milk or buttermilk")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 tablespoons bacon grease (optional, especially if using buttermilk)")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Combine all ingredients together. The batter should resemble pancake batter. If needed, additional flour or milk can be added to thicken or thin. Cook in hot greased frying pan as you would pancakes or pour into hot, well-greased frying pan and bake at 450 degrees until done.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" This recipe works best with corn that has begun to harden slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" Gritted bread is wonderful served with soup beans or with a smear of jelly.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P27-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A skillet of gritted bread. "), _c('i', [_vm._v("Tipper Pressley.")])])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Cornmeal Mush")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("Cornmeal mush makes a tasty breakfast cereal and can also be allowed to set up and sliced for frying, giving two options.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("2 cups water")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Pinch salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Honey, syrup or sugar")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Fried cornmeal mush. "), _c('i', [_vm._v("Tipper Pressley.")])])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Bring water to a boil; add salt; slowly add cornmeal, stirring constantly to prevent lumping. Continue cooking and stirring until thick and creamy. Serve with butter, sugar, honey or whatever pleases you.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" Cornmeal mush is called polenta in other cultures.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" Pour mush into a bread pan or other container and allow it to set up overnight. Remove from pan and slice; fry in hot grease until brown. Slices can be dipped into flour or egg to form a browner crust when fried.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Chestnut Dressing")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("½ cup butter or margarine")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup finely chopped celery")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup finely chopped onion")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 cup cooked, chopped chestnuts (you can substitute pecans)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("6–8 cups cornbread crumbs (homemade is better)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 egg, beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 (or more) cups chicken or turkey broth")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("Salt and pepper to taste (those who like sage can add it as well, but keep in mind it has a dominating flavor)")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Melt butter in skillet and sauté celery, onion and nuts. Cook slowly over low heat for 10 minutes; stir frequently, as this burns easily. Add to cornbread crumbs in mixing bowl. Add beaten egg and broth, mixing well. Dressing must be "), _c('i', [_vm._v("very")]), _vm._v(" moist; add more broth if needed. Season to taste with salt, pepper and sage (omit sage if you wish, which I do). Bake in casserole dish at 350 degrees for 30 to 45 minutes or until golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" Leftover dressing is just as tasty as when the preparation has just come from the oven, and it can be reheated for a side dish, adorned with gravy or mixed with chopped-up chicken or turkey and fried as cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Jim Casada")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Corn Pudding")]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("⅔ cup all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("½ cup cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 tablespoons sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 tablespoon baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 can cream-style corn")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 can whole-kernel corn (do not drain)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 small container (8 ounces) sour cream")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 stick butter")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Mix all ingredients—except butter—in a bowl. Pour into greased casserole dish. Melt butter and pour on top; do not stir. Bake uncovered at 350 degrees for 50 minutes or until light brown and set in the middle.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("NOTE:")]), _vm._v(" This recipe makes a good bread replacement.")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("TIP:")]), _vm._v(" A box of Jiffy Cornbread mix may be substituted for the first five ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Tipper Pressley")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Cornpone Pie")]), _vm._v(" "), _c('p', {
    staticClass: "steps1"
  }, [_c('i', [_vm._v("This recipe is really just a variation on time-tested approaches to making cornbread in a fashion that basically becomes, if not an entire meal, at least the key dish. In a sense, it is a derivative of both cracklin’ cornbread and cornbread with soup beans. The ingredients vary a bit from those traditional standards, and the meat and beans provide a double dose of protein.")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre1"
  }, [_c('i', [_vm._v("1 extra-large egg")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1⅓ cups buttermilk")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("¼ cup bacon drippings")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("2 cups stone-ground yellow cornmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("⅓ cup frozen corn kernels (optional; thaw them in advance)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("½ pound 80 percent lean hamburger or a comparable amount of venison ground with bacon ends or pork fat")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 medium onion, diced")])]), _vm._v(" "), _c('p', {
    staticClass: "ingre"
  }, [_c('i', [_vm._v("1 can pinto beans (drained) or 1½ cups previously cooked pintos")])]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("Mix egg, buttermilk, bacon drippings, cornmeal and corn kernels in a large bowl and whisk until thoroughly blended. (Or use your regular recipe for cornbread, leaving out the cooking oil.) Set batter aside (something I also do when making regular cornbread) while browning ½ pound of 80 percent lean hamburger or a comparable amount of ground venison (if you use the latter, mix in a bit of bacon or pork fat) in a skillet along with a diced sweet onion.")]), _vm._v(" "), _c('p', {
    staticClass: "steps2"
  }, [_vm._v("When the meat is fully browned, pour the pintos into the cornmeal batter, add the meat-and-onion mix, stir just enough to mix completely and pour into a preheated baking dish or well-greased cast-iron skillet. Bake at 400 degrees until done.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Jim Casada")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("GRITS AND HOMINY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grits aren’t made from cornmeal, but along with hominy, they fall into the category of dishes made from dried corn as opposed to its standard fresh vegetable usage. Accordingly, they seem a better fit here than in the vegetable recipes portion of the book. They are a standard source of dietary starch falling in the same category as breads. While most often served at breakfast, they can be an accompaniment to any meal.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/Common.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P31-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("An Indian woman preparing corn for a run of hominy. "), _c('i', [_vm._v("Courtesy of the National Park Service.")])])]), _vm._v(" "), _c('p', {
    staticClass: "recipe"
  }, [_vm._v("Fried Grits")]), _vm._v(" "), _c('p', {
    staticClass: "steps"
  }, [_vm._v("When allowed to cool after having been cooked, grits readily congeal. To enjoy fried grits, cook an extra batch when you are having them as a breakfast dish and place the surplus, while still warm enough to flow, in a baking dish or rectangular cake pan. Keep in refrigerator until ready to use, then cut into serving-size sections. Lightly oil a skillet and fry the grits cakes, turning once. Easy and scrumptious.")]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_vm._v("—Jim Casada")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 81
// module chunks = 0